import {
  IconCircleCheck,
  IconExclamationCircle,
  IconInfoCircle,
  IconTriangle,
} from '@tabler/icons-react';
import React from 'react';

import { ALERT_THEMES, AlertWrapper } from './Alert-styled-components';

const renderIcon = (theme: ALERT_THEMES, customIcon: React.ReactNode) => {
  if (customIcon) {
    return customIcon;
  }

  return (
    {
      [ALERT_THEMES.info]: <IconInfoCircle />,
      [ALERT_THEMES.success]: <IconCircleCheck />,
      [ALERT_THEMES.warning]: <IconTriangle />,
      [ALERT_THEMES.danger]: <IconExclamationCircle />,
      [ALERT_THEMES.error]: <IconExclamationCircle />,
    }[theme] || null
  );
};

interface AlertProps {
  theme: ALERT_THEMES;
  customIcon?: React.ReactNode;
  children: React.ReactNode;
}

export const Alert = ({ theme, customIcon, children }: AlertProps) => (
  <AlertWrapper theme={theme}>
    {renderIcon(theme, customIcon)}
    {children}
  </AlertWrapper>
);

